import PropTypes from 'prop-types'
import {
  TableCell,
  TableRow,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  TextField,
  FormHelperText,
  InputAdornment,
  Typography,
} from '@mui/material'
import { Clear } from '@mui/icons-material'

const ContractExtrasRow = ({
  extras,
  keyString,
  handleChange,
  deleteRow,
  formik,
  finalize,
  edit,
}) => {
  const id = Math.random()

  return (
    <TableRow>
      <TableCell>
        <FormControl
          fullWidth
          error={
            formik.touched.extras && !formik.values.extras[keyString].extra_id
          }
        >
          <Select
            disabled={finalize}
            value={
              formik.values.extras[keyString].extra_id
                ? formik.values.extras[keyString].extra_id
                : ''
            }
            onChange={(e) =>
              handleChange(e.target.value, 'extra_id', 1, keyString, 'extras')
            }
            id={`1-extra_id-${id}`}
            name={`1-extra_id-${id}`}
            variant="outlined"
          >
            {extras &&
              extras.length > 0 &&
              extras.map((option, keyString) => (
                <MenuItem key={keyString} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
          </Select>
          {formik.touched.extras &&
            !formik.values.extras[keyString].extra_id && (
              <FormHelperText>Wybierz koszt</FormHelperText>
            )}
        </FormControl>
      </TableCell>
      <TableCell>
        <FormControl fullWidth>
          <TextField
            disabled={finalize}
            value={formik.values.extras[keyString].quantity}
            error={
              formik.touched.extras &&
              Number(formik.values.extras[keyString].quantity) < 0
            }
            helperText={
              formik.touched.extras &&
              Number(formik.values.extras[keyString].quantity) < 0 &&
              'Wartość musi być większa niż 0'
            }
            type="number"
            id={`1-quantity-${id}`}
            name={`1-quantity-${id}`}
            onChange={(e) =>
              handleChange(e.target.value, 'quantity', 1, keyString, 'extras')
            }
          />
        </FormControl>
      </TableCell>
      <TableCell>
        <FormControl fullWidth>
          <TextField
            disabled={finalize}
            value={formik.values.extras[keyString].price_gross}
            error={
              formik.touched.extras &&
              Number(formik.values.extras[keyString].price_gross) < 0
            }
            helperText={
              formik.touched.extras &&
              Number(formik.values.extras[keyString].price_gross) < 0 &&
              'Wartość musi być większa niż 0'
            }
            type="number"
            id={`1-price_gross-${id}`}
            name={`1-price_gross-${id}`}
            onChange={(e) =>
              handleChange(
                e.target.value,
                'price_gross',
                1,
                keyString,
                'extras'
              )
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">zł</InputAdornment>
              ),
            }}
          />
        </FormControl>
      </TableCell>
      <TableCell>
        {/* <FormControl fullWidth>
          <TextField
            value={
              formik.values.extras[keyString].price_gross *
                formik.values.extras[keyString].quantity || 0
            }
            type="number"
            disabled={true}
            onChange={() => {}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">zł</InputAdornment>
              ),
            }}
          />
        </FormControl> */}
        {formik.values.extras[keyString].price_gross *
          formik.values.extras[keyString].quantity || 0}{' '}
        zł
        <Typography />
      </TableCell>
      {!(finalize || edit) && (
        <TableCell>
          <IconButton
            color="secondary"
            component="span"
            onClick={() => deleteRow(1, keyString)}
            size="large"
          >
            <Clear />
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  )
}

ContractExtrasRow.propTypes = {
  keyString: PropTypes.string,
  extras: PropTypes.array,
  formik: PropTypes.object,
  handleChange: PropTypes.func,
  deleteRow: PropTypes.func,
  finalize: PropTypes.bool,
  edit: PropTypes.bool,
}

export default ContractExtrasRow
